import './no-image.scss'

import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'

const NoImage = () => (
  <div className="container-no-image">
    <StaticImage
      src="../../assets/images/container-no-image.png"
      alt="no-image"
      layout="constrained"
      loading="eager"
    />
  </div>
)

export default NoImage
